import React, { Component } from "react";
import { Modal, Button, Icon } from "antd";
import "./index.scss";

class ShowImageModal extends Component {
  state = {
    index: 0,
    leftIconDisabled: true,
    rightIconDisabled: true,
  };

  videoRef = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    // When the modal visibility changes, update the index and button states.
    if (this.props.visible !== prevProps.visible) {
      this.setState(
        {
          index: this.props.defaultIndex,
        },
        () => {
          this.setState((state) => ({
            leftIconDisabled: state.index === 0,
            rightIconDisabled: state.index === this.props.files.length - 1,
          }));
        }
      );
    }

    // If the index has changed and a video element exists, force reload the video.
    if (prevState.index !== this.state.index && this.videoRef.current) {
      this.videoRef.current.load();
    }
  }

  getMediaUrl = (media) => {
    if (media) {
      return media.includes("https://")
        ? media
        : `${process.env.REACT_APP_API_URL}/disputes/get_dispute_media/${media}`;
    }
  };

  // Arrow functions ensure correct binding.
  onLeftClick = () => {
    let currentIndex = this.state.index - 1;
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    this.setState({
      index: currentIndex,
      leftIconDisabled: currentIndex === 0,
      rightIconDisabled: currentIndex === this.props.files.length - 1,
    });
  };

  onRightClick = () => {
    let currentIndex = this.state.index + 1;
    if (currentIndex >= this.props.files.length) {
      currentIndex = this.props.files.length - 1;
    }
    this.setState({
      index: currentIndex,
      leftIconDisabled: currentIndex === 0,
      rightIconDisabled: currentIndex === this.props.files.length - 1,
    });
  };

  render() {
    const { files, visible, toggleShowImageModal } = this.props;
    const { index, leftIconDisabled, rightIconDisabled } = this.state;
    let imageTag = true;
    if (files.length > 0) {
      // Determine if the file is an image or video based on its extension.
      imageTag = !files[index]
        .split(".")
        .pop()
        .toLowerCase()
        .includes("mp4");
    }

    return (
      <Modal
        title={null}
        visible={visible}
        onCancel={toggleShowImageModal}
        width={800}
        className="image-modal"
        footer={null}
      >
        <Button
          className="image-arrow"
          style={{ left: 0 }}
          onClick={this.onLeftClick}
          disabled={leftIconDisabled}
        >
          <Icon type="left" />
        </Button>

        <div className="img-wraper">
          {imageTag ? (
            <img
              src={this.getMediaUrl(files[index])}
              alt="Not found"
              className="image-size"
            />
          ) : (
            <video controls className="video-size" ref={this.videoRef}>
              <source src={this.getMediaUrl(files[index])} type="video/mp4" />
            </video>
          )}
        </div>

        <Button
          className="image-arrow"
          style={{ right: 0 }}
          onClick={this.onRightClick}
          disabled={rightIconDisabled}
        >
          <Icon type="right" />
        </Button>
      </Modal>
    );
  }
}

export default ShowImageModal;
